// extracted by mini-css-extract-plugin
module.exports = {"container":"_3WgCeB","outer-container":"_3LqJlq","challenge-detail-container":"_21ZE0y","page":"_2UcEmb"};